export const ORGANIZATION_TYPE_LABELS = {
	PARDOT: 'Pardot',
	SALESFORCE: 'Salesforce',
	SONAR: 'Arovy'
} as const;
